import(/* webpackMode: "eager" */ "/vercel/path0/app/instalaciones/page.tsx");
